export class ProductPallete {
  colors: any[];
  description: string;
  externalColorCode: string;
  externalId: string;
  id: number;

  constructor(s?: Partial<ProductPallete>) {
    if (s) {
      Object.assign(this, s);
    }
  }
}
